import {Player, Players} from './gamePlayerNew';
import * as STATES from './gameManagerConstants';
import ConnectionManager from './gameConnectionManager';
import DartsParser from './gameDartsParser';
import CpuOpponent from '../CpuOpponent';
import ControllerCommands from '../gameAssets/gameAssetControllerCommands'

import GameConnectionManager2 from '../gameAssets/gameConnectionManager2';

export default class GameManagerV2 {
    logged_in_player = null
    host = null
    gameoptions = {}
    starteroptions = {}
    startingPlayerId = -1
    gameInstance = null
    players = []
    playersClass = null
    gameState = null
    currentState = STATES.STARTOFGAME
    firstleg = false
    lastscore = null
    currentPlayer = null
    roundFinished = false

    connection = null

    lastMessageContentLength = 0 //bytesize of last received content message to prevent duplicate executes

    debugger = false

    constructor(game, instance) {
        this.debugger = localStorage.getItem("debugger") == "1";
        this.gameInstance = instance;
        this.game = game;
        this.gc = new GameConnectionManager2(game, instance.logged_in_player);

        this.debug("Game Manager loaded.", this);

        this.connect();
    }

    checkDebugKey(ev) {
        if (ev.code == "KeyD") {
            var localdebug = localStorage.getItem("debugger");
            if (localdebug == "1") {
                this.debugger = false;
                localStorage.setItem("debugger", "0");
                console.log("deactivated debugger");
            } else {
                this.debugger = true;
                localStorage.setItem("debugger", "1");
                console.log("activated debugger");
            }
        }
    }

    debug(message, args) {
        if (this.debugger === true) {
            if (args)
                console.log(message, args);
            else
                console.log(message);
        }
    }

    start() {
        this.debug("Starting up");
        this.setNextState();
    }

    connect() {
        this.gc.onProposeRematch = (e) => {
            console.log("game manager propose rematch", e)
            this.gameInstance.$root.$emit('GameManagerProposeRematch', e.status, e.newgame_id, e.usercount);
        }
    }


    setNextState(state) {
        if (!state) {
            //find current state in statemachine and set current state to next state
            for (let i = 0; i < STATES.STATEMACHINE.length; i++) {
                const st = STATES.STATEMACHINE[i];
                if (st === this.currentState && i < STATES.STATEMACHINE.length+1) {
                    this.currentState = STATES.STATEMACHINE[i+1];
                    break;
                } if (st === this.currentState && i <= STATES.STATEMACHINE.length+1) {
                    this.currentState = STATES.STATEMACHINE[0];
                    break;
                }
            }
        } else {
            this.currentState = state;
        }
        this.debug("current state: " + this.currentState);
        this.gameStates();
    }

    gameStates() {
        if (this.currentState == STATES.CREATINGOPTIONS)
            this.readOptions();
        else if (this.currentState == STATES.CREATINGUI)
            this.createUIElements();
        else if (this.currentState == STATES.CREATINGPLAYERS) {
            this.createPlayers();
            this.host = this.hostCheck();
            this.currentPlayer = this.playersClass.players[0]; //set to first player for now
            setTimeout(() => {
                this.gameInstance.playAudioFile("welcome");
            }, 0);
        } else if (this.currentState == STATES.CREATINGPLAYEROPTIONS)
            this.setPlayerOptions();
        else if (this.currentState == STATES.WAITFORCONNECTION) {
            this.connect().then(() => {
                this.setNextState();
            })
        }
        else if (this.currentState == STATES.CHECKFIRSTTHROW) {
            this.checkFirstThrow();
        }
        else if (this.currentState == STATES.SETTINGSTARTPLAYER) {
            this.controllerCommands.sendControllerEvent("gamestart")
            this.gameInstance.startingPlayerDetermined = true;
            this.gameInstance.playAudioFile("gameon");
            //starting player is set in the game with the vue component
        }
        else if (this.currentState == STATES.PREPAREACTIVEPLAYER) {
            this.prepareActivePlayer();
            this.currentPlayer = this.getActivePlayer();
        } else if (this.currentState == STATES.WAITINGFORINPUT) {
            if (this.logged_in_player != this.getActivePlayer().id) {
                //if the player on the site is not the active player, set state to wait for round end
                if (!this.getActivePlayer().guest || !this.host)
                    this.setNextState(STATES.WAITFORROUNDEND);
            }
            //waiting for input is set in the game
        }
        else if (this.currentState == STATES.WAITFORROUNDEND && this.getActivePlayer().cpu) {
            //make a cpu throw if logged_in_player is host
            if (this.host)
                this.cpuThrow();
        }
        else if (this.currentState == STATES.WINCHECK) {
            this.winCheck();
        }
        else if (this.currentState == STATES.WINCHECKSINGLE) {
            this.winCheckSingle();
        }
        else if (this.currentState == STATES.SETNEXTPLAYER) {
            this.setNextPlayer();
        }
        else if (this.currentState == STATES.ENDOFGAME) {
            this.endOfGame();
            this.controllerCommands.sendControllerEvent("gameend")
        }
    }


    readOptions() {
        //change game options into better readable format
        this.gameInstance.game.options.forEach(element => {
            this.gameoptions[element.name] = element.value;
        });
        //also change start options
        this.gameInstance.game.starting_options.forEach(element => {
            this.starteroptions[element.name] = element.value;
        });
        this.setNextState();
    }

    parseGameState() {
        var counter = 0;
        for (let i = 0; i < this.players.length; i++) {
            this.players[i].sets = this.gameState['sets_player' + (i+1)];
            this.players[i].legs = this.gameState['legs_player' + (i+1)];
            counter += this.players[i].sets;
            counter += this.players[i].legs;
        }
        this.firstleg = (counter == 0); //set first leg to true if this is the first leg.
    }

    createPlayers() {
        if (this.playersClass == null) {
            this.playersClass = new Players();
            this.players = [];
        }
        this.gameInstance.players_prop.forEach(player => {
            if (player.type == "computer") {
                this.playersClass.addPlayer(this.gameInstance.game, player, {start: parseInt(this.gameoptions.Start), cpu_time: this.starteroptions.cpu_time});
            } else {
                this.playersClass.addPlayer(this.gameInstance.game, player);
            }
        });
        this.players = this.playersClass.players;
        this.debug("gm players:", this.players);
    }

    //checks if current player is the host, for cpu throws
    hostCheck() {
        let host = false;
        this.players.forEach(player => {
            if (player.id == this.logged_in_player && player.user_id == this.gameInstance.game.user1_id) host = true;
        });
        return host;
    }

    createGuestPlayerObject() {
        this.playersClass.addGuest(this.gameInstance, 0, this.gameInstance.game.user1_id);
    }

    createCPUPlayerObject() {
        var start = this.gameoptions.start;
        var cpu_level = this.starteroptions.cpu_level;
        var cpu = this.playersClass.addCPU(this.gameInstance);
        var nextplayertimer = this.starteroptions.cpu_time;
        cpu.name = "CPU LVL" + cpu_level;
        cpu.brain = new CpuOpponent(start, cpu_level, this.gameInstance.game.id, nextplayertimer);
        this.players = this.playersClass.players;
    }

    cpuThrow() {
        this.getActivePlayer().brain.playRound(this.getActivePlayer().score);
    }

    //this is a callback function which triggers
    //the createUIElements function in the game
    createUIElements() {
        this.gameInstance.createUIElements().then( () => {
            this.setNextState();
        })
    }

    //this is a callback function which triggers
    //the setPlayerOptions method in the game
    setPlayerOptions() {
        this.gameInstance.setPlayerOptions().then( () => {
            this.setNextState();
        })
    }

    checkFirstThrow() {
        if (this.gameInstance.content == null) {
            this.debug("check first throw is true")
            this.gameInstance.startingPlayerDetermined = true;
            this.setNextState(STATES.SETTINGSTARTPLAYER);
        } else {
            this.debug("check first throw is false")
            this.setNextState(STATES.SETNEXTPLAYER);
        }
    }

    //this is a callback function which triggers
    //the setPlayerOptions method in the game
    prepareActivePlayer() {
        this.gameInstance.disabledInput = !(this.getActivePlayer().id == this.logged_in_player);
        //overwrite for guest
        if (this.getActivePlayer().guest && this.host) {
            this.gameInstance.disabledInput = false;
        }

        if (!this.gameInstance.disabledInput) this.gameInstance.playAudioFile("beep1");
        this.gameInstance.prepareActivePlayer().then( () => {
            this.setNextState();
        })
    }

    //this is a callback function which triggers
    //the winCheck method in the game
    winCheck() {
        this.gameInstance.winCheck().then( (data) => {
            if (data.winner) {
                this.setNextState(STATES.ENDOFGAME);
            } else {
                this.setNextState(STATES.SETNEXTPLAYER);
            }
        })
    }

    //this is a callback function which triggers
    //the winCheckSingle method in the game
    winCheckSingle() {
        this.gameInstance.winCheckSingle().then( (data) => {
            if (data.winner) {
                //dont call winner here, it will come from the server
                // this.setNextState(STATES.ENDOFGAME);
            } else {
                this.setNextState(STATES.WAITINGFORINPUT);
            }
        })
    }

    finishRound(throwScore) {
        this.playAudio(throwScore);
        this.roundFinished = true;
    }

    resetRound() {
        this.roundFinished = false;
    }

    endOfGame() {
        //check if end of game or end of leg
        if (this.gameInstance.game.status == "completed") {
            this.gameInstance.showWinner();
            this.gameInstance.playAudioFile("gameshotmatch");
            this.gameInstance.playAudioFile("win");
        } else {
            this.gameInstance.showNextLeg();
            this.gameInstance.playAudioFile("gameshot");
        }
        this.debug("Spiel beendet");
    }

    setActivePlayer(player_id, starter) {
        this.playersClass.activePlayer(player_id);
        if (starter) {
            this.startingPlayerId = player_id;
        }
    }

    getActivePlayer() {
        return this.playersClass.active_player;
    }

    isActivePlayer(id) {
        return this.playersClass.active_player && this.playersClass.active_player.id == id;
    }

    setNextPlayer() {
        this.gameInstance.active_player = this.playersClass.loadNextPlayer();
        if (this.getActivePlayer().id != this.logged_in_player)
            this.gameInstance.playAudioFile("beep2");
        this.setNextState(STATES.PREPAREACTIVEPLAYER);
    }

    playAudio(data) {
        this.gameInstance.playAudio(data);
    }

    startNextLeg() {
        this.lastMessageContentLength = 0
        this.gameInstance.startingPlayerDetermined = false;
        this.gameInstance.content = null;
        this.setNextState(STATES.CREATINGPLAYEROPTIONS)
    }

    inGamePlayerCheck(user_id) {
        this.players.forEach(player => {
            if (player.user_id == user_id) return true;
        });
        return false;
    }
}
